// Dependencies
import styled from "styled-components";

// Utils
import { theme } from "config/theme";

export const Container = styled.div`
    display: block;

    font-family: "Nunito", sans-serif;
    font-style: normal;
    font-size: 0.875rem;
    font-weight: 600;

    letter-spacing: 0.01em;
    line-height: 1.571;
    padding-block: 0.5rem;

    color: ${theme.colors.base[500]};

    &.level-1:nth-child(1) {
        padding-top: 0;
    }

    &.level-1 {
        padding-left: 16px;
    }

    &.level-2 {
        padding-left: 32px;
    }

    &.level-3 {
        padding-left: 48px;
    }

    &:last-of-type {
        padding-top: 0;
        padding-bottom: 0.25rem;
    }
`;
